import React, { useState } from 'react'
import { TextArea } from 'components'
import { useSelector } from 'hooks'
import { userCriteria } from 'common/criteria'
import { StyledPersonal, StyledPersonalTab, StyledPersonalTabs } from './MyProfile/Tabs/Personal/StyledPersonal'
import Block, { CriteriaBlock } from './MyProfile/Block'

const CoupleTabs = ({ className, profile, notOwnProfile = false }) => {
  const adult = useSelector(s => s.flags.adult)
  const couple = profile.members.length > 1
  const [activeTab, setActiveTab] = useState(0)

  return (
    <>
      {couple && (
        <>
          <StyledPersonalTabs className={className}>
            <StyledPersonalTab className={activeTab == 0 ? 'active' : ''} onClick={() => setActiveTab(0)}>
              Person 1
            </StyledPersonalTab>
            <StyledPersonalTab className={activeTab == 1 ? 'active' : ''} onClick={() => setActiveTab(1)}>
              Person 2
            </StyledPersonalTab>
          </StyledPersonalTabs>
          <StyledPersonal className={className + (activeTab == 1 ? '' : ' hidden')}>
            <div className="row">
              {userCriteria(profile.members[1], adult).map(id => (
                <CriteriaBlock
                  key={id}
                  id={id}
                  person="2"
                  user={profile}
                  notOwnProfile={notOwnProfile}
                  disabled={notOwnProfile}
                />
              ))}
            </div>
          </StyledPersonal>
        </>
      )}
      <StyledPersonal className={className + (activeTab == 0 ? '' : ' hidden')}>
        <div className="row">
          <Block label="aboutMe">
            <TextArea name="aboutMe" defaultValue={profile.aboutMe} disabled={notOwnProfile} />
          </Block>
        </div>
        <div className="row">
          {userCriteria(profile.members[0], adult).map(id => (
            <CriteriaBlock key={id} id={id} user={profile} notOwnProfile={notOwnProfile} disabled={notOwnProfile} />
          ))}
        </div>
      </StyledPersonal>
    </>
  )
}

export default CoupleTabs
